import hnbIcon from 'assets/img/hnb-icon.svg'
import AssetType from 'state/enums/AssetType'

import { FramePath, HomeTabPath } from './types'

export const toTabItems = (
    brandNewsPathUrl: string | undefined,
    assetTypes: AssetType[],
    isAgreementSignedWithHnb: boolean | undefined,
    enableHnbIntegration: boolean | undefined,
    isDefault: boolean | undefined,
): FramePath[] => {
    const items: FramePath[] = []

    // TODO: consider branded crossover dealerships
    if (assetTypes.length === 1) {
        if (brandNewsPathUrl && !isDefault)
            return [
                {
                    path: brandNewsPathUrl as HomeTabPath,
                    name: 'Branded',
                },
            ]
    }

    if (assetTypes.includes(AssetType.POWERSPORTS_VEHICLE)) {
        items.push({ path: 'dealer-news', name: 'Powersports' })

        if (enableHnbIntegration) {
            if (isAgreementSignedWithHnb) {
                items.push({
                    path: 'mower-dealer-news',
                    name: 'Outdoor Power Equipment',
                    icon: hnbIcon,
                })
            } else {
                items.push({
                    path: 'hnb-signup',
                    name: 'Outdoor Power Equipment',
                    icon: hnbIcon,
                })
            }

            items.push({ path: 'tractor-dealer-news', name: 'Tractor' })
            items.push({ path: 'trailer-dealer-news', name: 'Trailer' })
        }
    }

    if (assetTypes.includes(AssetType.MARINE)) {
        items.push({
            path: 'marine-dealer-news',
            name: 'Marine',
        })
    }

    if (assetTypes.includes(AssetType.RECREATIONAL_VEHICLE)) {
        items.push({
            path: 'rv-dealer-news',
            name: 'Recreational Vehicle',
        })
    }

    if (assetTypes.includes(AssetType.AUTOMOBILE)) {
        items.push({
            path: 'auto-dealer-news',
            name: 'Automotive',
        })
    }

    return items
}
